<template>
    <v-container :fluid="$vuetify.breakpoint.md">
        <v-row justify="center">
            <v-col md="12">
                <v-card color="primary" dark width="100%">
                    <v-card-title class="d-block py-2 text-center font-weight-bold primary white--text" style="word-break: normal">MIS PAGOS</v-card-title>
                    <v-btn bottom color="secondary primary--text" depressed fab absolute right small @click="getPayments(1)">
                        <v-icon>mdi-sync</v-icon>
                    </v-btn>
                </v-card>
            </v-col>
        </v-row>
        <v-row justify="center">
            <v-col md="12">
                <v-card>
                    <v-card-title>
                        <v-text-field v-model="Search" append-icon="mdi-magnify" label="Buscar" single-line hide-details/>
                    </v-card-title>
                    <v-data-table :headers="Headers" :items="Payments" :search="Search" :loading="loading"
                                  :no-data-text="noDataText" :footer-props="footerProps" dense>
                        <template v-slot:item.id="{ item }">
                            <strong>{{ item.id }}</strong>
                        </template>
                        <template v-slot:item.status="{ item }">
                            <v-chip small label :color="getColor(item.status_id)" dark>
                                <strong>{{ item.status }}</strong>
                            </v-chip>
                        </template>
                        <template v-slot:item.action="{ item }">
                            <v-btn color="info" small depressed class="ma-1" title="Ver" @click="getVoucher(item.id)" v-if="item.voucher">
                                <v-icon>mdi-image-area</v-icon>
                            </v-btn>
                            <v-btn color="primary" small depressed class="ma-1" :title="item.status_id === 201 ? 'Pagar' : 'Detalles'" :to="'/payments/' + item.id">
                                <v-icon>mdi-{{ item.status_id === 201 ? 'cash' : 'eye' }}</v-icon>{{ item.status_id === 201 ? ' Pagar' : '' }}
                            </v-btn>
                        </template>
                    </v-data-table>
                </v-card>
                <v-dialog v-model="view" scrollable max-width="1000" width="80%">
                    <v-card>
                        <v-card-title class="text-center headline primary white--text d-inline-block" style="word-break: normal; width: 100%">Comprobante # {{ voucherId }}</v-card-title>
                        <v-card-text>
                            <img :src="'/' + voucher" :alt="voucherId" width="100%" />
                        </v-card-text>
                        <v-divider/>
                        <v-card-actions>
                            <v-spacer/>
                            <v-btn color="error" @click="view = false"><v-icon>mdi-close-circle</v-icon> Cerrar</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import axios from 'axios';

    export default {
        name: "Payments",
        props: [ 'user' ],
        data: () => ({
            Search: '',
            Headers: [
                { text: 'ID', value: 'id', align: 'right' },
                { text: 'Valor', value: 'amount', align: 'right', sortable: false },
                { text: 'Moneda', value: 'currency', align: 'left', sortable: false },
                { text: 'Estado', value: 'status', align: 'center', sortable: false },
                { text: 'Creación', value: 'created_at', align: 'right', sortable: false },
                { text: 'Aprobación', value: 'date_pay', align: 'right', sortable: false },
                { text: 'Acción', value: 'action', align: 'center', filterable: false, sortable: false }
            ],
            Payments: [],
            loading: true,
            noDataText: 'No tienes pagos pendientes',
            footerProps: {
                itemsPerPageOptions: [25, 50, 100, 250, -1]
            },
            voucherId: null,
            voucher: null,
            view: false
        }),
        mounted() {
            this.getPayments();
        },
        methods: {
            getPayments(v) {
                clearTimeout(this.timeout);
                if (v === 1) {
                    this.loading = true;
                    this.Payments = [];
                }
                axios.get('/api/payments').then((res) => {
                    this.Payments = res.data.payments;
                }).catch(err => {
                    this.handleErrors(err.response.data.errors);
                }).then(() => {
                    this.loading = false;
                });
                this.timeout = setTimeout(this.getPayments, 180000);
            },
            getColor(status) {
                if (status === 203) return 'success';
                else if (status === 201) return 'primary';
                else if (status === 204 || status === 205 || status === 206) return 'error';
                else return 'tertiary';
            },
            getVoucher(id) {
                let items = this.Payments;
                for (let i = 0; i < items.length; i++) {
                    if (items[i].id === id) {
                        this.voucher = items[i].voucher;
                    }
                }
                this.voucherId = id;
                this.view = true;
            }
        },
        destroyed() {
            clearTimeout(this.timeout);
        }
    }
</script>

<style scoped>

</style>
